module.exports = __webpack_public_path__ + "img/ncm-change.93c82471.jpg";